@if (data) {
  <div class="icon">
    <span class="icon-circle">
      <mat-icon>close</mat-icon>
    </span>
  </div>
  <div class="content">
    <span class="title">{{ "SNACKBAR.ERROR" | translate }}</span>
    <p [innerHTML]="data | translate"></p>
  </div>
}
